export const name = 'hoverBox' as const
